import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2965c6bb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2965c6bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965c6bb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeHeader: require('/var/www/jaty-frontend/components/HomeHeader.vue').default,FacebookButton: require('/var/www/jaty-frontend/components/FacebookButton.vue').default,HomeStory: require('/var/www/jaty-frontend/components/HomeStory.vue').default,MarketingComparisons: require('/var/www/jaty-frontend/components/marketing/Comparisons.vue').default,HomeFooter: require('/var/www/jaty-frontend/components/HomeFooter.vue').default})
